import Select from './select';
import SelectOption from './select-option';

Select.SelectOption = SelectOption;

export default Select;
